module.exports = __webpack_public_path__ + "img/logo-water-meter.045bc2f3.png";